import { Tabs } from 'tailwindcss-stimulus-components';

export default class extends Tabs {
  static targets = ['tab', 'panel'];
  
  connect() {
    super.connect();
  }

  change(event) {
    super.change(event);

    this.tabTargets.forEach((tab) => {
      tab.classList.remove('border-b-2', 'border-blue-500');
      tab.querySelector('a').classList.remove('text-blue-500', 'hover:text-blue-700');
      tab.querySelector('a').classList.add('text-gray-500', 'hover:text-gray-700');
    });

    event.currentTarget.classList.add('border-b-2', 'border-blue-500');
    event.currentTarget.querySelector('a').classList.remove('text-gray-500', 'hover:text-gray-700');
    event.currentTarget.querySelector('a').classList.add('text-blue-500', 'hover:text-blue-700');
  }

  filterTeam(event) {
    const search = event.target.value.toLowerCase();
    
    this.panelTargets.forEach(panel => {
      const cards = panel.querySelectorAll('[data-user-card]');
      cards.forEach(card => {
        const name = card.dataset.userName?.toLowerCase() || '';
        const role = card.dataset.userRole?.toLowerCase() || '';
        const roleName = card.dataset.userRoleName?.toLowerCase() || '';

        if (name.includes(search) || role.includes(search) || roleName.includes(search)) {
          card.classList.remove('hidden');
        } else {
          card.classList.add('hidden');
        }
      });
    });
  }
}
